import { render, staticRenderFns } from "./TransactionTotal.vue?vue&type=template&id=12ff0b7e&scoped=true&"
import script from "./TransactionTotal.vue?vue&type=script&lang=ts&"
export * from "./TransactionTotal.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionTotal.vue?vue&type=style&index=0&id=12ff0b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff0b7e",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign({QBtn}, component.options.components || {})
